import React, { useState } from 'react';
import supabase from '../supabase';


export const AgentTerminal = () => {
  const [code, setCode] = useState('');
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const performAudit = async () => {
    if (!code) return;
    setLoading(true);
    setError(null);
    setStats(null);

    // 1. Verification: Check if the Coupon Code exists in Profiles
    const { data: agent, error: agentError } = await supabase
      .from('profiles')
      .select('id, agent_referral_code')
      .eq('agent_referral_code', code.toUpperCase().trim())
      .single();

    if (agentError || !agent) {
      setError("ACCESS DENIED: INVALID OR REVOKED AGENT CODE");
      setLoading(false);
      return;
    }

    // 2. Data Ingestion: Fetch conversion stats for this Agent ID
    const { data: referrals, error: refError } = await supabase
      .from('referrals')
      .select('amount, created_at, status')
      .eq('agent_id', agent.id);

    if (refError) {
      setError("SYSTEM ERROR: FAILED TO RETRIEVE ANALYTICS");
      setLoading(false);
      return;
    }

    // 3. Calculation: Process 14-day hold and total revenue
    const now = new Date();
    const fourteenDaysAgo = new Date(now.setDate(now.getDate() - 14));

    const processedStats = {
      totalConversions: referrals.length,
      grossRevenue: referrals.reduce((acc, curr) => acc + curr.amount, 0),
      availablePayout: referrals
        .filter(r => new Date(r.created_at) < fourteenDaysAgo)
        .reduce((acc, curr) => acc + curr.amount, 0),
      pendingHold: referrals
        .filter(r => new Date(r.created_at) >= fourteenDaysAgo)
        .length
    };

    setStats(processedStats);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#d1d1d1] font-mono p-6 lg:p-20 selection:bg-[#333]">
      <div className="max-w-2xl mx-auto">
        
        {/* Terminal Header */}
        <header className="mb-12 border-b border-[#222] pt-24 pb-6">
          <h1 className="text-xs tracking-[0.4em] uppercase text-[#444] mb-2">Sitemanifest // Distribution Terminal</h1>
          <p className="text-xl font-bold text-white tracking-tighter">AGENT PERFORMANCE AUDIT</p>
        </header>

        {/* Search Interface */}
        <section className="mb-12">
          <div className="flex flex-col md:flex-row gap-2">
            <input 
              type="text" 
              placeholder="ENTER YOUR CODE" 
              className="flex-1 bg-[#111] border border-[#222] p-4 text-white uppercase tracking-widest focus:border-[#555] outline-none transition-all placeholder:text-[#333]"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && performAudit()}
            />
            <button 
              onClick={performAudit}
              disabled={loading}
              className="bg-white text-black px-10 py-4 font-bold uppercase hover:bg-[#bbb] disabled:opacity-50 transition-all"
            >
              {loading ? 'AUDITING...' : 'RUN AUDIT'}
            </button>
          </div>
          {error && <p className="mt-4 text-red-800 text-[10px] uppercase font-bold tracking-widest">{error}</p>}
        </section>

        {/* Results Module */}
        {stats && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-in fade-in duration-500">
            <div className="bg-[#111] border border-[#222] p-6">
              <span className="text-[10px] text-[#444] uppercase tracking-widest block mb-1">Total Acquisitions</span>
              <span className="text-3xl text-white font-bold">{stats.totalConversions}</span>
            </div>
            <div className="bg-[#111] border border-[#222] p-6">
              <span className="text-[10px] text-[#444] uppercase tracking-widest block mb-1">Gross Revenue</span>
              <span className="text-3xl text-white font-bold">${stats.grossRevenue}</span>
            </div>
            <div className="bg-[#111] border border-[#222] p-6 border-l-2 border-l-green-900">
              <span className="text-[10px] text-green-800 uppercase tracking-widest block mb-1">Available for Payout</span>
              <span className="text-3xl text-white font-bold">${stats.availablePayout}</span>
            </div>
            <div className="bg-[#111] border border-[#222] p-6">
              <span className="text-[10px] text-[#444] uppercase tracking-widest block mb-1">Units on 14-Day Hold</span>
              <span className="text-3xl text-white font-bold">{stats.pendingHold}</span>
            </div>
          </div>
        )}

        <footer className="mt-20 text-[10px] text-[#333] uppercase tracking-[0.2em]">
          Payouts occur on the 1st and 15th of each month. 
          <br />System latency: Real-time via Paddle Webhooks.
        </footer>
      </div>
    </div>
  );
};